import styles from './OpenMenu.scss';

import cx from 'classnames';
import { ReferencedEntry } from 'contentful';
import React from 'react';

import { Navigation } from 'src/api/contentful/contentTypes.cloverdotcom';
import { CloseButton } from 'src/components/CloseButton/CloseButton';
import { ContentLink } from 'src/components/ContentLink/ContentLink';
import { withSidebarContext } from 'src/components/SidebarContext/WithSidebarContext';
import { getField } from 'src/utils/EntryUtil';
import { processNavigation } from 'src/utils/NavigationUtil';
import { SidebarNav } from '../SidebarNav/SidebarNav';

export interface IOpenMenu extends React.AllHTMLAttributes<HTMLDivElement> {
  closeSidebar: () => void;
  children?: never;
  entry?: ReferencedEntry<Navigation>;
}

const OpenMenu: React.FC<IOpenMenu> = ({
  entry,
  closeSidebar,
  hidden,
  className,
  ...props
}) => (
  <nav
    tabIndex={hidden ? -1 : 0}
    className={cx(styles.openMenu, { [styles.openMenuHidden]: hidden }, className)}
    aria-hidden={hidden ? true : undefined}
    {...props}
  >
    <div className={styles.openMenuBody}>
      {!hidden && <CloseButton onClick={closeSidebar} />}
      {entry && <SidebarNav entry={processNavigation(entry)} />}
    </div>
    {entry && (
      <ContentLink
        data-test={'primary-link'}
        entry={getField(entry, 'primaryLink')}
        className={cx(className, styles.openMenuPrimaryLink)}
      />
    )}
  </nav>
);

const SidebarContexted = withSidebarContext(({ close }) => ({ closeSidebar: close }))(OpenMenu);

export {
  SidebarContexted as OpenMenu,
  OpenMenu as _OpenMenu,
};
